export default "__VITE_ASSET__1f405657__"